var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferenceNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.139,
    height: 19.588,
    viewBox: "0 0 17.139 19.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42794",
    "data-name": "Group 42794",
    transform: "translate(-43.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33__21_",
    transform: "translate(43.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42793",
    "data-name": "Group 42793",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189472",
    "data-name": "Path 189472",
    d: "M56.569,0H49.223a2.55,2.55,0,0,0-2.448,2.449l-.708.017A2.451,2.451,0,0,0,43.714,4.9V17.139a2.55,2.55,0,0,0,2.448,2.448h9.182a2.55,2.55,0,0,0,2.448-2.448H58.4a2.55,2.55,0,0,0,2.449-2.448V4.912ZM55.344,18.364H46.162a1.284,1.284,0,0,1-1.224-1.224V4.9a1.214,1.214,0,0,1,1.166-1.2l.67-.02V14.691a2.55,2.55,0,0,0,2.448,2.448h7.345A1.284,1.284,0,0,1,55.344,18.364Zm4.285-3.673A1.284,1.284,0,0,1,58.4,15.915H49.223A1.284,1.284,0,0,1,48,14.691V2.449a1.284,1.284,0,0,1,1.224-1.224h6.121c-.01,1.41,0,2.464,0,2.464a2.522,2.522,0,0,0,2.448,2.433h1.836ZM57.793,4.9c-.652,0-1.224-1.184-1.224-1.82V1.243h0L59.629,4.9ZM56.569,8.581H51.059a.612.612,0,1,0,0,1.223h5.509a.612.612,0,1,0,0-1.223Zm0,3.058H51.059a.612.612,0,1,0,0,1.223h5.509a.612.612,0,1,0,0-1.223Z",
    transform: "translate(-43.714)",
    fill: "#15b5d8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenceNumber);
export default __webpack_public_path__ + "static/media/ReferenceNumber.f6142daed05e5150fd8df75811a4fd1c.svg";
export { ForwardRef as ReactComponent };